import { TSignalType, TStatus } from 'common/types'

import { TFilters } from '../types/MyServices.types'

export const IS_SEND_DOCUMENTS_ENABLED = true

export const SUPPORT_STATUS = {
  completed: 'Completed',
  underReview: 'Under Review',
  canceled: 'Canceled',
  all: 'All',
}

export const FILTER_DICTIONARY: Record<TStatus, TFilters> = {
  OPEN: 'UNDER_REVIEW',
  'IN PROGRESS': 'UNDER_REVIEW',
  PENDING: 'UNDER_REVIEW',
  RESOLVED: 'COMPLETED',
  CLOSED: 'COMPLETED',
  CANCELLED: 'CANCELED',
  ABANDONED: 'CANCELED',
  AWAITING_SALESFORCE_TICKET_CREATION: 'AWAITING',
}
export const baseState = {
  pageTitle: '',
  newSupportButtonLabel: '',
  emptyRequest: {
    icon: '',
    title: '',
    subtitle: '',
    type: 'gray' as TSignalType,
  },
  emptyFilter: {
    icon: '',
    title: '',
    subtitle: '',
    type: 'gray' as TSignalType,
  },
  filteredServices: [],
  baseServices: [],
  filterChips: [],
  isLoading: false,
}

export const RELOAD_BUTTON = {
  iconRef: 'core/action-navigation/ic_rotate_right',
  color: 'var(--secondary500)',
  size: 24,
}
